var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInternalServerError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 566.93 566.93",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fd2fd2f7-5b85-4f15-ae36-bda5891f1d57"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.46,
    cy: 283.46,
    r: 283.46,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "e50b5e71-3bb7-41c9-acd2-09265743f459",
    "data-name": "Copy"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 283.46,
    cy: 283.46,
    r: 283.46
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#fd2fd2f7-5b85-4f15-ae36-bda5891f1d57)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "124.36 72.51 124.36 929.59 163.17 929.59 163.17 117.5 478.31 117.5 478.31 929.59 517.12 929.59 517.12 72.51 124.36 72.51",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.89,
    y: 104.04,
    width: 333.7,
    height: 841.35,
    style: {
      fill: "#464646"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.9,
    y: 115.36,
    width: 309.69,
    height: 816.37,
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.19,
    cy: 467.74,
    r: 23.34,
    style: {
      fill: "#464646"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.47,462.12a7.78,7.78,0,1,1-7.78-7.78A7.78,7.78,0,0,1,221.47,462.12Z",
    style: {
      fill: "#b9b9b9",
      mixBlendMode: "screen",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.19,533.36a7.59,7.59,0,0,1-7.58-7.58V512.62a7.58,7.58,0,0,1,15.15,0v13.16A7.59,7.59,0,0,1,218.19,533.36Z",
    style: {
      fill: "#595654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.19,527.18h0a3.08,3.08,0,0,0,3.07-3.07V514.3a3.08,3.08,0,0,0-3.07-3.07h0a3.08,3.08,0,0,0-3.08,3.07v9.81A3.08,3.08,0,0,0,218.19,527.18Z",
    style: {
      fill: "#23212b"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "200.06 188.96 325.57 86.62 452.32 232.16",
    style: {
      fill: "none",
      stroke: "#ededed",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.48,
    cy: 90.12,
    r: 7.55,
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.8 352.66 185.85 317.07 199.5 187.27 450.45 222.86 436.8 352.66",
    style: {
      fill: "#73be00",
      stroke: "#73be00",
      strokeLinejoin: "round",
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.23 347.77 190.94 312.79 203.82 192.41 447.11 227.39 434.23 347.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,238.81l-1.91,13.51a16.79,16.79,0,0,1-5.53,1.62,24.77,24.77,0,0,1-6.6-.07q-7.24-1-10.37-6.12-2.85-4.63-1.8-12.07,1.26-8.94,7.1-12.49a14.24,14.24,0,0,1,9.61-1.76,13.44,13.44,0,0,1,11,7.89l-6.5,3.5q-2.34-4.17-5.54-4.63a5.06,5.06,0,0,0-4.93,1.95,12.6,12.6,0,0,0-2.33,6.25q-1.43,10.13,4.93,11a8.14,8.14,0,0,0,3.37-.1l1.37-9.65Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.84,255.87l4.42-31.31,8.14,1.15L282,249.91l12.48,1.76-1,7.11Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.49,259.49l4.43-31.3,20.48,2.89-1,7.06L310,236.39l-.68,4.76,10.64,1.5-1,7.06-10.64-1.5-.76,5.36,12.71,1.8-1,7.06Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05,264.37l-8.1-1.14,4.42-31.31,8.1,1.15Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.67,261.24c2.16.3,4.51-.42,7-2.18l3.35,5.85a17.23,17.23,0,0,1-5.69,2.68,16,16,0,0,1-6.05.22q-7.21-1-10.42-6.17Q340,257,341.06,249.8q1.29-9.08,7.21-12.61a14.51,14.51,0,0,1,9.85-1.78q7.15,1,10.43,8.1l-6.33,3.33q-2.27-4.31-5.42-4.75a5.16,5.16,0,0,0-4.94,2,12.94,12.94,0,0,0-2.4,6.43q-.7,5,.74,7.69A5.65,5.65,0,0,0,354.67,261.24Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.66,240.72l8.14,1.15-4.42,31.31L387.23,272,389,259.88l-9.89-1.39-1.71,12.14-8.1-1.14,4.42-31.31,8.1,1.15-1.7,12,9.88,1.4Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,275.57l-15.82,18.56L249,296l-.88,6.21L225.26,299l.7-5,15.51-18.36L229,273.9l.87-6.16L252,270.86Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.94,271.55,265,272.7l-2.89,20.48q-.66,4.65,3.77,5.28a4,4,0,0,0,3.33-.82,4.54,4.54,0,0,0,1.48-3l2.93-20.72,8.1,1.15-3.06,21.65a9.16,9.16,0,0,1-5,7.27,14.51,14.51,0,0,1-8.9,1.19q-6.6-.93-9.19-4.33c-1.56-2-2.1-4.82-1.6-8.34Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.53,296.7l-1.66,11.72-8.1-1.14L288.2,276l11.2,1.58q6.21.88,8.87,3.51c1.74,1.75,2.39,4.12,2,7.1a8.94,8.94,0,0,1-6,7.27,4.61,4.61,0,0,1,1.73,2.74l3.57,12.75-8.66-1.22L298,299.15a2.64,2.64,0,0,0-2.24-2.14Zm.87-6.22,3.07.44c2.57.36,4-.73,4.39-3.27a2.78,2.78,0,0,0-.93-2.87,6.72,6.72,0,0,0-3.08-1l-2.45-.35Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,280.05l8.09,1.14-2.89,20.48q-.66,4.66,3.77,5.29a4,4,0,0,0,3.33-.83,4.54,4.54,0,0,0,1.48-3l2.93-20.71,8.1,1.14-3.06,21.66a9.12,9.12,0,0,1-5,7.26,14.44,14.44,0,0,1-8.9,1.19q-6.6-.93-9.19-4.32c-1.56-2-2.1-4.83-1.6-8.34Zm4.41-5.09a3.24,3.24,0,0,1,1.36-2.31,3.74,3.74,0,0,1,2.75-.57,3.58,3.58,0,0,1,2.57,1.52,3.18,3.18,0,0,1,.57,2.38,3.23,3.23,0,0,1-1.35,2.31,4.15,4.15,0,0,1-5.23-.74A3.21,3.21,0,0,1,321.47,275Zm10.31,1.45a3.24,3.24,0,0,1,1.38-2.3,3.82,3.82,0,0,1,2.77-.57,3.6,3.6,0,0,1,2.58,1.52,3.25,3.25,0,0,1,.57,2.39,3.2,3.2,0,0,1-1.38,2.27,4.1,4.1,0,0,1-5.25-.72A3.21,3.21,0,0,1,331.78,276.41Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.64,311.66q3.25.46,7-2.18l3.35,5.86a17,17,0,0,1-5.68,2.67,16,16,0,0,1-6.06.23q-7.2-1-10.41-6.18Q344,307.44,345,300.23q1.29-9.09,7.21-12.62a14.58,14.58,0,0,1,9.86-1.77q7.15,1,10.42,8.1l-6.32,3.33q-2.28-4.31-5.43-4.76a5.18,5.18,0,0,0-4.94,2,13.09,13.09,0,0,0-2.4,6.43c-.46,3.29-.22,5.86.74,7.69A5.62,5.62,0,0,0,358.64,311.66Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.21,292.22,392.39,303.9l6.54,19.65-9.23-1.31-4-12.38-3.32,3.42-1.1,7.77-8-1.14,4.43-31.3,8.05,1.14-1.79,12.61L394.26,291Z",
    style: {
      fill: "#73be00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.23 347.77 190.94 312.79 203.82 192.41 447.11 227.39 434.23 347.77",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInternalServerError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/internal-server-error.25b749b212691fe4cc96947c66ca45b7.svg";